import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useApp } from "../lib/store";
import { SupplierContactsPanel } from "../components/SupplierContactsPanel";
import { Users } from "lucide-react";

export default function SupplierContacts() {
  const { t } = useApp();
  const [caps, setCaps] = useState([]);
  useEffect(() => { api.get("/srm/my-caps").then((r) => setCaps(r.data.caps || [])).catch(() => {}); }, []);
  const canWrite = caps.includes("supplier_write");

  return (
    <div className="p-6 max-w-[1400px] mx-auto space-y-6" data-testid="supplier-contacts-page">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-[#1B2A4A] flex items-center justify-center">
          <Users className="h-6 w-6 text-[#F5A623]" strokeWidth={1.75} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#1B2A4A]">{t("supplier_contacts")}</h1>
          <p className="text-sm text-gray-500">{t("supplier_contacts_sub")}</p>
        </div>
      </div>
      <SupplierContactsPanel canWrite={canWrite} />
    </div>
  );
}
